__webpack_require__.p = "/cosmic-traders/";